import ProductList from './ProductList';
import { ProductListProps, ProductListValueProps } from './types';

export type { ProductListProps, ProductListValueProps };
export default ProductList;
